// extracted by mini-css-extract-plugin
export default {"detailscont":"Wrapper_detailscont__CnX9X","grid":"Wrapper_grid__ixvrr","subCont":"Wrapper_subCont__M66bj"};